import React, { useState } from "react";

import { Box, Button, LinearProgress, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { CloudUpload } from "@mui/icons-material";

import useApi from "../../hooks/useApi";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const FileUpload = ({
  entityName,
  entityId,
  data,
  onUploaded,
  buttonStyle,
}) => {
  const { upload } = useApi();

  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("idle");
  const [progress, setProgress] = useState(0);
  const [isProcessLocked, setIsProcessLocked] = useState(false);

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
      setStatus("idle");
      setProgress(0);
      setIsProcessLocked(false);
    }
  };

  const handleUpload = async () => {
    if (!file || isProcessLocked) return;

    setIsProcessLocked(true);
    setStatus("uploading");
    setProgress(0);

    try {
      const args = { entityName, id: entityId, file, data };

      await upload(args, (progress) => {
        setProgress(progress);
      });

      setStatus("success");
      setProgress(100);
      onUploaded();
    } catch {
      setStatus("error");
      setProgress(0);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
    >
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUpload />}
        sx={buttonStyle}
      >
        Upload file
        <VisuallyHiddenInput
          type="file"
          onChange={handleFileChange}
          multiple
        />
      </Button>
      {/* <input
        type="file"
        onChange={handleFileChange}
      /> */}
      {file && (
        <Box>
          <Typography>{`Filename: ${file.name}`}</Typography>
          <Typography>{`Size: ${(file.size / 1024).toFixed(2)} KB`}</Typography>
          <Typography>{`Type: ${file.type}`}</Typography>
        </Box>
      )}
      {file && status !== "uploading" && (
        <Button
          size="small"
          variant="contained"
          onClick={handleUpload}
          disabled={isProcessLocked}
        >
          Process
        </Button>
      )}
      {status === "uploading" && (
        <Box sx={{ width: "200px" }}>
          <LinearProgress
            variant="determinate"
            value={progress}
          />
        </Box>
      )}
    </Box>
  );
};

export default FileUpload;
